export enum CheckBoostTargetEnum {
  LinkedChannel = "LINKED_CHANNEL",
  Group = "GROUP",
  FrontendCustom = "CUSTOM",
}
